const state = {
  productList: []
}

const mutations = {
  setProductList(state, productList) {
    state.productList = productList
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
